<template>
	<app background="#fff">
		<account-edit ref="accountEdit"></account-edit>
		
		<button-list-m slot="foot">
			<c-button @click="submit">确认并提交</c-button>
		</button-list-m>
	</app>
</template>

<script>
	import accountEdit from './account_edit_form.vue'
	
	export default {
		components: {
			accountEdit
		},
		
		props: {
			id: String
		},
		
		mounted() {
			if (this.id) {
				this.$refs.accountEdit.edit(this.id);
			} else {
				this.$refs.accountEdit.add();
			}
		},
		
		methods: {
			submit() {
				this.$refs.accountEdit.submit().then(() => {
					this.$message({
						text: '提交成功',
						resolve: () => {
							this.navigateTo('/system_list', {tab: 1});
						}
					});
				});
			}
		}
	};
</script>

<style lang="stylus" scoped>
</style>